import { render, staticRenderFns } from "./RodadasCompraProdutoBadge.vue?vue&type=template&id=ccdf83ec"
import script from "./RodadasCompraProdutoBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./RodadasCompraProdutoBadge.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports